export default function GetImageUrl(folder, file) {
  return process.env.REACT_APP_API_BASE_URL+"/uploads/" + folder + "/" + file;
}